export const CART_KEY = 'eto-russia.cart.v1';
export const CHECKOUT_KEY = 'eto-russia.checkout.v1';
export const MAX_QUANTITY = 50;
export const MAX_CART_QUANTITY = 50;

export const loadCart = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
        if (!Array.isArray(stored)) return [];
        const seen = new Set();
        let count = 0;
        return stored.filter(item => {
            if (!Number.isInteger(item?.variant_id) || seen.has(item.variant_id) ||
                !Number.isInteger(item.product_id) || typeof item.name !== 'string' || typeof item.size !== 'string' ||
                !Number.isInteger(item.available_quantity) || item.available_quantity < 0 ||
                !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > MAX_QUANTITY ||
                !Number.isFinite(item.price) || item.price < 0 || count + item.quantity > MAX_CART_QUANTITY) return false;
            seen.add(item.variant_id);
            count += item.quantity;
            return true;
        });
    } catch { return []; }
};

export const loadCheckout = () => {
    try {
        const value = JSON.parse(sessionStorage.getItem(CHECKOUT_KEY) || 'null');
        return value?.body?.idempotency_key && Array.isArray(value.items) ? value : null;
    } catch { return null; }
};

export const saveCheckout = value => {
    try {
        if (value) sessionStorage.setItem(CHECKOUT_KEY, JSON.stringify(value));
        else sessionStorage.removeItem(CHECKOUT_KEY);
    } catch { /* Checkout remains usable when storage is unavailable. */ }
};

export const cartReducer = (items, action) => {
    if (action.type === 'remove') return items.filter(item => item.variant_id !== action.id);
    if (action.type === 'paid') {
        return items.map(item => ({ ...item, quantity: item.quantity - (action.items.find(paid => paid.variant_id === item.variant_id)?.quantity || 0) }))
            .filter(item => item.quantity > 0);
    }
    if (action.type === 'add') {
        const { product, variant } = action;
        if (!variant?.is_active || variant.available_quantity < 1) return items;
        const existing = items.find(item => item.variant_id === variant.id);
        if (items.reduce((total, item) => total + item.quantity, 0) >= MAX_CART_QUANTITY) return items;
        if (existing) return items.map(item => item.variant_id === variant.id
            ? { ...item, quantity: Math.min(item.quantity + 1, variant.available_quantity, MAX_QUANTITY) } : item);
        return [...items, { variant_id: variant.id, product_id: product.id, name: product.name, color: product.color_name,
            size: variant.size, image: product.images?.[0] || '', price: Number(variant.price ?? product.price),
            available_quantity: Math.min(MAX_QUANTITY, variant.available_quantity), quantity: 1 }];
    }
    if (action.type === 'quantity') {
        const otherCount = items.reduce((total, item) => total + (item.variant_id === action.id ? 0 : item.quantity), 0);
        return items.map(item => item.variant_id === action.id ? { ...item,
            quantity: Math.max(1, Math.min(Math.floor(Number(action.quantity)) || 1, MAX_QUANTITY, MAX_CART_QUANTITY - otherCount,
                Math.max(1, item.available_quantity))) } : item);
    }
    if (action.type === 'refresh') return items.map(item => {
        const product = action.products.find(product => product.id === item.product_id);
        const variant = product?.variants?.find(variant => variant.id === item.variant_id);
        if (!variant) return { ...item, available_quantity: 0 };
        return { ...item, name: product.name, color: product.color_name, image: product.images?.[0] || '',
            price: Number(variant.price ?? product.price), available_quantity: variant.is_active ? Math.min(MAX_QUANTITY, variant.available_quantity) : 0 };
    });
    return items;
};
